/**
 * Tap-to-answer options under Study Buddy's question, styled like the Quiz
 * MCQ boxes (A, B, C, D). The tapped option is sent as the student's reply.
 */
import { useState } from 'react';

const LETTERS = ['A', 'B', 'C', 'D'];

export function AnswerChoices({ choices = [], messageId, disabled, onPick }) {
  const [picked, setPicked] = useState(null);
  if (!choices.length) return null;
  return (
    <div className="mt-3 space-y-2" data-testid={`chat-choices-${messageId}`}>
      {choices.map((c, i) => {
        const isPicked = picked === i;
        return (
          <button key={c} type="button" disabled={disabled || picked !== null}
            data-testid={`chat-choice-btn-${messageId}-${i}`}
            onClick={() => { setPicked(i); onPick(`(${LETTERS[i]}) ${c}`); }}
            className={`w-full flex items-center gap-3 text-left px-3.5 py-2.5 rounded-2xl border-2 text-[13px] font-body transition-colors duration-200 ${isPicked
              ? 'border-blue-500 bg-blue-50 text-blue-900'
              : picked !== null ? 'border-slate-100 bg-white text-slate-400'
                : 'border-slate-200 bg-white text-slate-700 hover:border-blue-400 hover:bg-blue-50/50'}`}>
            <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-heading font-bold flex-shrink-0 ${isPicked ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-600'}`}>
              {LETTERS[i]}
            </span>
            <span className="flex-1">{c}</span>
          </button>
        );
      })}
    </div>
  );
}

export default AnswerChoices;
